import { useContext } from "react";
import { DefaultLayout } from "../../layouts/DefaultLayout";
import Grid from "@mui/material/Unstable_Grid2";
import { MappingKeys } from "../../components/media/mappingKeys/MappingKeys";
import { AppContext } from "../root/Root";

export const Media = () => {
  useContext(AppContext);
  return (
    <DefaultLayout>
      <Grid
        className="page-content"
        container
        rowSpacing={{ xs: 3, md: 0 }}
        columnSpacing={{ xs: 0, md: 2 }}
        padding={{ xs: 1, md: 2 }}
        disableEqualOverflow
      >
        <Grid md={12}>
          <MappingKeys />
        </Grid>
      </Grid>
    </DefaultLayout>
  );
};
